<template>
    
    <v-dialog max-width="290" v-model="show">
        <v-card>
            <v-card-title class="headline">Confirmation</v-card-title>
                <v-card-text>{{confirmationMessage}}</v-card-text>
                <v-card-actions>
                    <v-btn depressed color="green darken-1" flat="flat" @click="dialogClose(false)">No</v-btn>
                    <v-btn depressed color="red darken-1" flat="flat" @click="dialogClose(true)">Yes</v-btn>
                </v-card-actions>
            </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: "confirmation",
        props: ['visible', 'message'],
        methods: {
            dialogClose (value) {
                this.show = false;
                this.$emit('clicked', value);
            }
        },
        computed: {
            show: {
                get () {
                    return this.visible
                },
                set (value) {
                    if (!value) {
                        this.$emit('close')
                    }
                }
            },
            confirmationMessage: {
                get () {
                    return (this.message)? this.message : 'Are you sure?'
                }
            }
        }
    };
</script>

<style>
    .modal-backdrop {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 2;
    }

    .modal {
        background: #ffffff;
        box-shadow: 2px 2px 20px 1px;
        overflow-x: auto;
        display: flex;
        flex-direction: column;
    }

    .modal-header,
    .modal-footer {
        padding: 15px;
        display: flex;
    }

    .modal-header {
        border-bottom: 1px solid #eeeeee;
        color: #4aae9b;
        justify-content: space-between;
    }

    .modal-footer {
        border-top: 1px solid #eeeeee;
        justify-content: flex-end;
    }

    .modal-body {
        position: relative;
        padding: 20px 10px;
    }

    .btn-close {
        border: none;
        font-size: 20px;
        padding: 20px;
        cursor: pointer;
        font-weight: bold;
        color: #4aae9b;
        background: transparent;
    }

    .btn-green {
        color: white;
        background: #4aae9b;
        border: 1px solid #4aae9b;
        border-radius: 2px;
    }
</style>
